export default function sleep(timeout){
  return new Promise(function (resolve, reject) {
    setTimeout(() => {
      resolve("timeout end");
      reject("something went wrong")
    }, timeout);
  });
}